<template>
    <v-container class="px-0 py-0" fluid>
        <v-app-bar color="#008dd4" height="160">
            <v-toolbar-title>
                <v-img src="/images/neumann-logo-contorno.png" class="mx-auto" width="250"></v-img>
            </v-toolbar-title>
        </v-app-bar>
        <v-row align="center" justify="center">
            <v-col class="px-6 py-6" cols="12" lg="8" md="8" sm="12" style="position:relative; margin-top: -60px">
                <v-card>
                    <v-card-title>Selecciona el idioma de tu interés</v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col v-for="(language, index) in languages" cols="12" lg="3" md="6" sm="12" :key="index">
                                <v-card outlined class="rounded-lg" @click="redirect(language)" elevation="2">
                                    <v-card-text>
                                        <v-img class="rounded-xl mx-auto" :src="language_image_url+language.image" width="180" height="150"></v-img>
                                    </v-card-text>
                                    <v-card-actions>
                                        <p class="mx-auto" style="font-size: 18px">
                                            <strong>
                                                {{ language.language }}
                                            </strong>
                                        </p>
                                    </v-card-actions>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-divider></v-divider>
                    <!-- <v-card-actions>
                        <p class="text--disabled my-5 mx-auto">¿No encuentras el idioma que buscas? has clic <a href="#" @click="(e) => {  e.preventDefault(); new_language = true  }">aquí</a></p>
                    </v-card-actions> -->
                </v-card>
            </v-col>
        </v-row>

        <v-dialog v-model="new_language" max-width="800" persistent>
            <v-card>
                <v-card-title>
                    Nuevo idioma
                </v-card-title>
                <v-card-text>
                    <p>Por favor ingrese la información requerida, nos pondremos en contacto con usted cuando tengamos disponible el idioma que busca.</p>
                    <v-form>
                        <v-text-field filled label="Idioma"></v-text-field>
                        <v-text-field filled label="Nombre(s)"></v-text-field>
                        <v-text-field filled label="Correo electrónico"></v-text-field>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="new_language = false">Cancelar</v-btn>
                    <v-btn color="#008dd4" dark>Aceptar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
export default {
    props:['languages'],
    data: () => ({
        language_image_url:"/storage/langs_disk/",
        new_language:false,
    }),

    methods:{
        redirect:function(language){
            window.location = "/placement-test/"+language.code
        }
    }
}
</script>